module.exports = __webpack_public_path__ + "static/media/Dacia Morris Headshot.3fdb96f5.jpeg";